var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center",staticStyle:{"height":"100vh"}},[_c('h1',[_vm._v(" Page not found ")])])
}]

export { render, staticRenderFns }